<template>
  <v-layout class="mb-2 justify-space-around"
            wrap
            row
            id="downloadButtons">
    <v-flex xs4>
      <a :href="apple"
         target="_blank">
        <img class="ios"
             width="60%"
             src="/image/apple-store-badge-WHITE.png" />
      </a>
    </v-flex>
    <v-flex xs4>
      <a :href="android"
         target="_blank">
        <img class="android"
             width="60%"
             src="/image/google-play-badge-WHITE.png" />
      </a>
    </v-flex>
    <v-flex xs4>
      <a :href="huawei"
         target="_blank">
        <img class="huawei"
             width="60%"
             src="/image/huawei-appgallery-badge-WHITE.png" />
      </a>
    </v-flex>
  </v-layout>
</template>

<script>
import store from '@/store';

const configFile = require(process.env.VUE_APP_CONFIG)
const config = configFile.config

export default {
  name: 'DownloadApp',
  computed: {
    android() {
      return config.SITE[store.state.countrySelected.code].APP.ANDROID
    },
    apple() {
      return config.SITE[store.state.countrySelected.code].APP.APPLE
    },
    huawei() {
      return 'https://appgallery.cloud.huawei.com/ag/n/app/C101270523?channelId=site&id=163e069517e04686b02f8d00b7973422&s=02CA11903D7DF1B04BF3D189381E0FDC71058552C1D62C27E9F412F0C1F9A8F8&detailType=0&v='
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.xs #downloadButtons img {
  width:80%
}
.sm #downloadButtons img {
 width:65%
}
.md #downloadButtons img {
  width:60%
}
.lg #downloadButtons img {
  width:35%
}

.xs #downloadButtons img.huawei{
  float:right
}
.xs #downloadButtons img.android{
  float:left;
  margin-left:10%;
}
.xs #downloadButtons img.ios{
  float:left
}

.sm #downloadButtons img.huawei,
.md #downloadButtons img.huawei,
.lg #downloadButtons img.huawei {
  float:left
}

.sm #downloadButtons img.android{
  float:left;
  margin-left:12%;
}
.md #downloadButtons img.android{
  float:left;
  margin-left:20%;
}
.lg #downloadButtons img.android {
  float:left;
  margin-left:32%;
}

.sm #downloadButtons img.ios,
.md #downloadButtons img.ios,
.lg #downloadButtons img.ios{
  float:right
}
</style>
